import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams, currencyFormatter } from '../CustomUtils'
import { LIST_INVOICES_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid.js'
import ReportHeading from '../ReportHeading.js'
import ReportTotalsRow from '../ReportTotalsRow.js'
import CSVLink from '../../CSVLink/CSVLink.js'
import { getTenant } from '../../../utils.js'

const LIST_INVOICES = gql(LIST_INVOICES_QUERY)

export default function ListInvoices({ location }) {
  console.log('ListInvoices rendered:', location)

  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, LIST_INVOICES, 'listInvoices', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const totalColumns = [
      { columnNumber: 5 },
      { columnNumber: 6 },
      { columnNumber: 7 }
    ]
    const columnFormatters = [
      { columnNumber: 5, formatter: currencyFormatter().format, align: 'right' },
      { columnNumber: 6, formatter: currencyFormatter().format, align: 'right' },
      { columnNumber: 7, formatter: currencyFormatter().format, align: 'right' },
    ]
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/Asbestos/listInvoices/list_invoices.csv?inputs=${JSON.stringify(inputs)}`
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <CSVLink url={csvUrl} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={results.otherData.plaintiffName} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} columnFormatters={columnFormatters} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumns} />
          </tbody>
        </Table>
      </div>
    )
  }
}